// Cartograph subtree desk filters (Alpine component factory).
// Filters by title/author/id text and age band; dims or hides non-matches
// while keeping ancestors of hits visible.
export function cgTreeFilters() {
  return {
    q: "",
    age: "any", // any | fresh | month | year
    hide: false,
    init() {
      this.apply();
    },
    ageMs() {
      const day = 86400000;
      switch (this.age) {
        case "fresh": return 7 * day;
        case "month": return 30 * day;
        case "year": return 365 * day;
        default: return null;
      }
    },
    apply() {
      const root = this.$root;
      if (!root) return;
      const nodes = Array.from(root.querySelectorAll(".cg-tree-node"));
      const now = Date.now();
      const maxAge = this.ageMs();
      const q = this.q.trim().toLowerCase();
      const filtering = q.length > 0 || maxAge != null;

      const matched = new Map();
      nodes.forEach((el) => {
        const ts = Number(el.dataset.cgTs || 0);
        const hay = `${el.dataset.cgTitle || ""} ${el.dataset.cgAuthor || ""} ${el.dataset.cgId || ""}`.toLowerCase();
        let ok = true;
        if (q && !hay.includes(q)) ok = false;
        if (ok && maxAge != null && ts && now - ts > maxAge) ok = false;
        if (ok && maxAge != null && !ts) ok = false;
        matched.set(el, ok);
      });

      const keep = new Set();
      if (filtering) {
        nodes.forEach((el) => {
          if (!matched.get(el)) return;
          let cur = el;
          while (cur && cur.classList && cur.classList.contains("cg-tree-node")) {
            keep.add(cur);
            const parentLi = cur.parentElement;
            cur = parentLi ? parentLi.closest(".cg-tree-node") : null;
          }
        });
      }

      nodes.forEach((el) => {
        const isMatch = matched.get(el);
        const isKeep = !filtering || keep.has(el);
        el.classList.toggle("cg-tree-node--hit", filtering && isMatch);
        el.classList.toggle("cg-tree-node--dim", filtering && isKeep && !isMatch);
        el.hidden = this.hide && filtering && !isKeep;
        if (!filtering) {
          el.classList.remove("cg-tree-node--hit", "cg-tree-node--dim");
          el.hidden = false;
        }
      });
    },
  };
}

if (typeof window !== "undefined") {
  window.cgTreeFilters = cgTreeFilters;
}
